var map = {
	"./locale-provider/bg_BG.tsx": 896,
	"./locale-provider/ca_ES.tsx": 897,
	"./locale-provider/cs_CZ.tsx": 898,
	"./locale-provider/de_DE.tsx": 899,
	"./locale-provider/en_GB.tsx": 900,
	"./locale-provider/en_US.tsx": 901,
	"./locale-provider/es_ES.tsx": 902,
	"./locale-provider/et_EE.tsx": 903,
	"./locale-provider/fi_FI.tsx": 904,
	"./locale-provider/fr_BE.tsx": 905,
	"./locale-provider/fr_FR.tsx": 906,
	"./locale-provider/it_IT.tsx": 907,
	"./locale-provider/ja_JP.tsx": 908,
	"./locale-provider/ko_KR.tsx": 909,
	"./locale-provider/nl_BE.tsx": 910,
	"./locale-provider/nl_NL.tsx": 911,
	"./locale-provider/pl_PL.tsx": 912,
	"./locale-provider/pt_BR.tsx": 913,
	"./locale-provider/ru_RU.tsx": 914,
	"./locale-provider/sk_SK.tsx": 915,
	"./locale-provider/sv_SE.tsx": 917,
	"./locale-provider/tr_TR.tsx": 918,
	"./locale-provider/vi_VN.tsx": 919,
	"./locale-provider/zh_TW.tsx": 920
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 852
// module chunks = 0